<template>
  <div class="bottom-box">
    <div class="bottom-con">
      <ul class="clearfix">
        <li>
          <a data-stat="底部导航-主会场" href="javascript:void(0)">主会场</a>
        </li>
        <li @click="toOthers('1')" v-show="type!=0">
          <a data-stat="底部导航-地区分会场" href="javascript:void(0)">地区分会场</a>
        </li>
        <li @click="toOthers('2')">
          <a data-stat="底部导航-品类分会场" href="javascript:void(0)">品类分会场</a>
        </li>
        <!-- <li @click="toOthers('2')">
          <a data-stat="底部导航-超级返利购" href="javascript:void(0)">超级返利购</a>
        </li>-->
      </ul>
    </div>
  </div>
</template>  

<script>
import Vue from "vue";
import * as URL from "../../assets/js/url.js";
import { Tabbar, TabItem } from "mint-ui";
Vue.component(Tabbar.name, Tabbar);
Vue.component(TabItem.name, TabItem);
export default {
  props: ["type"],
  data() {
    return {
      selected: "tab-one"
    };
  },
  methods: {
    toOthers(type) {
      location.href =
        type == 1
          ? "//www.ule.com/event/tmpl/ulewap.html?actId=257"
          : type == 2
          ? "//www.ule.com/event/tmpl/ulewap.html?actId=258"
          : "//www.ule.com/event/2019/0624/brokerage/index.html";
    }
  }
};
</script>
<style lang="less">
/* 底部导航 */
.bottom-box {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99999;
}
.bottom-box .bottom-con {
  height: 1.28rem;
  width: 100%;
  display: block;
  margin: 0 auto;
  max-width: 640px;
  background-color: #fff;
  position: relative;
}
.bottom-con ul {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
}
.bottom-con li {
  width: 25%;
  height: 100%;
  float: left;
}
.bottom-con li a {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 0.24rem;
  color: #767676;
  text-align: center;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/tab_icon01.png)
    no-repeat center 0.06rem;
  background-size: 0.85rem 0.84rem;
  padding-top: 0.9rem;
}
.bottom-con li:nth-of-type(2) a {
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/tab_icon02.png)
    no-repeat center 0.06rem;
  background-size: 0.85rem 0.84rem;
}
.bottom-con li:nth-of-type(3) a {
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/tab_icon03.png)
    no-repeat center 0.06rem;
  background-size: 0.85rem 0.84rem;
}
.bottom-con li:nth-of-type(4) a {
  background: url("../../assets/images/fl.png") no-repeat center 0.06rem;
  background-size: 0.85rem 0.84rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabBar.vue